// Design tokens ACP - Values driven by brand config
// Chakra UI v3 token format
import { getBrand } from '../brand/index.js'

const brand = getBrand()

export const acpTokens = {
  colors: {
    acp: {
      blue: { value: brand.theme.colors.blue },
      blueLight: { value: brand.theme.colors.blueLight },
      blueSoft: { value: brand.theme.colors.blueSoft ?? '#e8f2fb' },
      bluePress: { value: brand.theme.colors.bluePress ?? '#045c99' },
      blueStrong: { value: brand.theme.colors.blueStrong ?? '#034a7c' },
      gold: { value: brand.theme.colors.gold },
      goldSoft: { value: brand.theme.colors.goldSoft ?? '#faf4e2' },
      goldStrong: { value: brand.theme.colors.goldStrong ?? '#8a7220' },
      purple: { value: brand.theme.colors.purple ?? '#9673a6' },
      purpleSoft: { value: brand.theme.colors.purpleSoft ?? '#f1ecf4' },
      purpleStrong: { value: brand.theme.colors.purpleStrong ?? '#6e4f7e' },
      green: { value: brand.theme.colors.green ?? '#82b366' },
      greenSoft: { value: brand.theme.colors.greenSoft ?? '#eef6e8' },
      greenStrong: { value: brand.theme.colors.greenStrong ?? '#5a8a40' },
      red: { value: brand.theme.colors.red ?? '#d0563f' },
      redSoft: { value: brand.theme.colors.redSoft ?? '#fbeae6' },
      redStrong: { value: brand.theme.colors.redStrong ?? '#b23b26' },
      ink: { value: brand.theme.colors.ink },
      inkSoft: { value: brand.theme.colors.inkSoft },
      inkFaint: { value: brand.theme.colors.inkFaint },
      bg: { value: brand.theme.colors.bg },
      bgSoft: { value: brand.theme.colors.bgSoft },
      surface: { value: brand.theme.colors.surface },
      surfaceAlt: { value: brand.theme.colors.surfaceAlt },
      line: { value: brand.theme.colors.line },
      lineStrong: { value: brand.theme.colors.lineStrong },
    },
  },
  fonts: {
    heading: { value: brand.theme.fonts.heading },
    body: { value: brand.theme.fonts.body },
    mono: { value: brand.theme.fonts.mono },
    display: { value: brand.theme.fonts.display },
    eyebrow: { value: brand.theme.fonts.eyebrow },
  },
  radii: {
    card: { value: brand.theme.radii.card },
    button: { value: brand.theme.radii.button },
  },
}

export const UI_TOKENS = {
  border: {
    subtle: 'acp.line',
    default: 'acp.line',
    emphasis: 'acp.lineStrong',
  },
  background: {
    subtle: 'acp.bgSoft',
    muted: 'acp.bg',
    canvas: 'acp.surface',
  },
  text: {
    muted: 'acp.inkFaint',
    subtle: 'acp.inkSoft',
  },
} as const

export type AcpColor = keyof typeof acpTokens.colors.acp
export type UIBorderToken = keyof typeof UI_TOKENS.border
export type UIBackgroundToken = keyof typeof UI_TOKENS.background
export type UITextToken = keyof typeof UI_TOKENS.text
